import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Header, Group, Button, Text, Burger, MediaQuery, Box, useMantineTheme } from '@mantine/core';
import { IconWand, IconPlus } from '@tabler/icons-react';
import { useAuth } from '../context/AuthContext';

interface NavbarProps {
  burgerProps: {
    opened: boolean;
    onClick: () => void;
    size: string;
  };
}

const Navbar: React.FC<NavbarProps> = ({ burgerProps }) => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useMantineTheme();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const isHomePage = location.pathname === '/';

  return (
    <Box
      sx={{
        height: '100%',
        background: `linear-gradient(135deg, ${theme.colors.indigo[6]}, ${theme.colors.indigo[8]})`,
        padding: '0 1rem',
      }}
    >
      <Group position="apart" sx={{ height: '100%' }}>
        <Group spacing="lg">
          {user && (
            <MediaQuery largerThan="sm" styles={{ display: 'none' }}>
              <Burger
                opened={burgerProps.opened}
                onClick={burgerProps.onClick}
                size={burgerProps.size}
                color={theme.white}
              />
            </MediaQuery>
          )}
          <Box component={Link} to="/" sx={{ textDecoration: 'none' }}>
            <Group spacing="xs">
              <IconWand size={24} color={theme.white} />
              <Text 
                size="lg" 
                weight={700} 
                sx={{ 
                  color: theme.white,
                  fontFamily: theme.headings.fontFamily,
                }}
              >
                Learning Genie
              </Text>
            </Group>
          </Box>
        </Group>

        <Group spacing="md">
          {user && !isHomePage && (
            <Button
              variant="white"
              leftIcon={<IconPlus size={18} />}
              onClick={() => navigate('/')}
              sx={{
                fontWeight: 600,
                transition: 'transform 0.2s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  backgroundColor: theme.white,
                },
              }}
            >
              Create Course
            </Button>
          )}
          {user ? (
            <>
              <Text 
                size="sm" 
                sx={{ 
                  color: theme.white,
                  opacity: 0.9,
                  '@media (max-width: 600px)': {
                    display: 'none',
                  },
                }}
              >
                {user.email}
              </Text>
              <Button
                variant="white"
                color="dark"
                onClick={handleSignOut}
                sx={{
                  fontWeight: 600,
                  transition: 'transform 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    backgroundColor: theme.white,
                  },
                }}
              >
                Sign Out
              </Button>
            </>
          ) : (
            <Button
              component={Link}
              to="/login"
              variant="white"
              color="dark"
              sx={{
                fontWeight: 600,
                transition: 'transform 0.2s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  backgroundColor: theme.white,
                },
              }}
            >
              Sign In
            </Button>
          )}
        </Group>
      </Group>
    </Box>
  );
};

export default Navbar; 